import React from 'react';
import cn from 'classnames';
import T from 'prop-types';

const Chip = ({ label, className, active, onSelect }) => {
  return (
    <div
      className={cn('Chip', {
        active,
        [className]: className,
      })}
      onClick={onSelect}
    >
      {label}
    </div>
  );
};

Chip.propTypes = {
  label: T.string.isRequired,
  className: T.string,
  active: T.bool,
  onSelect: T.func,
};

export { Chip };
